module.exports = __webpack_public_path__ + "static/media/[Professor_Teas]2015-09-08.b4848854.md";